import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ModalMessage = (props) => {
    const handleClose = (props) => props.setMessageStatus(false);

    return (
        <>
            <Modal show={props.show} onHide={() => {
                props.setMessageStatus(false)
            }}>
                <Modal.Header className={props.headerBackground} closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => {
                        props.setMessageStatus(false)
                    }}>
                        {props.btnCloseText}
                    </Button>                    
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalMessage;